import React from 'react';
import propTypes from 'prop-types';
import ToolbarComponent from '../UI/Toolbar';
import LeftToolbar from './LeftToolbar';
import CenterToolbar from './CenterToolbar';
import RightToolbar from './RightToolbar';
import CommonImageComponent from './ToolbarItems/imageItem';

class Toolbar extends React.PureComponent {
  state = {};

  render() {
    const {
      leftList,
      centerList,
      rightList,
      // eslint-disable-next-line react/prop-types
      className,
      pathname,
      isTop,
      user,
      inviteId,
      formatType,
      setDrawerState,
      sideDrawerToggleHandler,
      appType,
      showSideDrawer,
      navBarRef,
      userPreferences,
      universityPlan,
      LinkComponent,
      ProfileIcon,
      Notifications,
      MobileToolbar,
      CommonToolbar,
      ImageComponent = CommonImageComponent,
      organizationIdentity,
    } = this.props;

    return (
      <ToolbarComponent
        page={className}
        pathname={pathname}
        isTop={isTop}
        showSideDrawer={showSideDrawer}
        formatType={formatType}
        navBarRef={navBarRef}
        userPreferences={userPreferences}
        appType={appType}
      >
        <LeftToolbar
          appType={appType}
          leftList={leftList}
          page={className}
          pathname={pathname}
          isTop={isTop}
          user={user}
          formatType={formatType}
          universityPlan={universityPlan}
          LinkComponent={LinkComponent}
          ImageComponent={ImageComponent}
          organizationIdentity={organizationIdentity}
        />
        <CenterToolbar
          appType={appType}
          centerList={centerList}
          page={className}
          pathname={pathname}
          isTop={isTop}
          formatType={formatType}
          LinkComponent={LinkComponent}
        />
        <RightToolbar
          appType={appType}
          rightList={rightList}
          pathname={pathname}
          user={user}
          isTop={isTop}
          inviteId={inviteId}
          formatType={formatType}
          sideDrawerToggleHandler={sideDrawerToggleHandler}
          setDrawerState={setDrawerState}
          LinkComponent={LinkComponent}
          ImageComponent={ImageComponent}
          ProfileIcon={ProfileIcon}
          Notifications={Notifications}
          MobileToolbar={MobileToolbar}
          CommonToolbar={CommonToolbar}
        />
      </ToolbarComponent>
    );
  }
}

Toolbar.propTypes = {
  leftList: propTypes.objectOf(
    propTypes.oneOf([propTypes.string, propTypes.object]),
  ).isRequired,
  centerList: propTypes.objectOf(
    propTypes.oneOf([propTypes.string, propTypes.object]),
  ).isRequired,
  // rightList: propTypes.objectOf(
  //   propTypes.oneOf([propTypes.string, propTypes.object])
  // ).isRequired,
  pathname: propTypes.string.isRequired,
  isTop: propTypes.bool.isRequired,
  user: propTypes.objectOf(propTypes.object),
};

Toolbar.defaultProps = {
  user: {},
};

export default Toolbar;
